import { Skeleton } from '../Skeleton'

interface SkeletonStatsProps {
  count?: number
}

// Mirrors `.st-stats.bordered`: single bordered/shadowed strip, 85px row,
// `repeat(count, 1fr)` with border-right separators between cells.
export function SkeletonStats({ count = 4 }: SkeletonStatsProps) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${count}, 1fr)`,
        gridAutoRows: 85,
        border: 'var(--border) solid var(--ink)',
        background: 'var(--paper)',
        boxShadow: 'var(--shadow-sm)'
      }}>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          style={{
            padding: '14px 20px',
            borderRight: i < count - 1 ? 'var(--border) solid var(--ink)' : undefined,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: 8,
            overflow: 'hidden'
          }}>
          <Skeleton.Bar w="55%" h={10} />
          <Skeleton.Bar w="40%" h={32} />
        </div>
      ))}
    </div>
  )
}
